<template>
  <div class="acompanhamento-mensal-container">
    <transition name="fade" mode="out-in">
      <div v-if="carregando" class="start-questionario text-center py-4">
        <b-spinner variant="warning" />
        <h5 class="mb-1 fw-bold text-uppercase">
          {{ startActionTitle }}
        </h5>
        <p class="mb-0">
          {{ startActionDescription }}
        </p>
      </div>
    </transition>

    <div v-if="erro" show class="mb-0">
      <div class="d-flex justify-content-center align-items-center">
        <ErroPergunta />
      </div>
    </div>

    <div v-else class="conteudo-campanha">
      <transition name="fade" mode="out-in">
        <QuestionarioForm
          @erro="handleErro"
          ref="questionarioForm"
          v-if="questionarioData"
          :titulo="questionarioTitulo"
          :cd-pessoa="cdCooperadoAtual"
          :questionario-data="questionarioData"
          @submit-resposta="handleSubmitResposta"
          @form-state-change="handleFormStateChange"
          @resposta-valida="handleValidacaoResposta"
          @respostas-enviadas="handleRespostasEnviadas"
        />
      </transition>
    </div>
  </div>
</template>

<script lang="js">
import QuestionarioForm from "../components/QuestionarioForm.vue";
import { questionarioAdapter } from "../adapters/questionarioAdapter";
import { questionarioService } from "../services/questionarioService";
import ErroPergunta from "../components/ErroPergunta.vue";
import { verificarPendenciaService } from "../../shared/services/verificarPendenciaService";
import confetti from "canvas-confetti";

export default {
  name: "AcompanhamentoMensalContainer",

  components: {
    ErroPergunta,
    QuestionarioForm,
  },

  props: {
    cdCooperado: {
      type: [String, Number],
      default: null
    },
    footerAction: {
      type: String,
      default: ""
    },
    startActionTitle: {
      type: String,
      default: "Preparando questionário"
    },
    startActionDescription: {
      type: String,
      default: "Estamos verificando suas pendências."
    }
  },

  data() {
    return {
      carregando: false,
      erro: null,
      questionarioData: null,
      cdCooperadoAtual: null,
      cdProcedAtual: null,
      questionarioTituloData: "",
      loadingAction: "",
      fluxoIniciado: false,
      perguntasVistas: new Set(),
      totalEstimado: 0,
      formState: {
        current: 0,
        total: 0,
        percent: 0,
        isPrimeiraPergunta: true,
        isUltimaPergunta: false,
        respostaValida: false,
        bloquearProximo: false,
        minimoCaracteres: 15,
        comprimentoResposta: 0,
        enviando: false
      }
    };
  },

  watch: {
    footerAction(action) {
      if (!action) {
        return;
      }

      this.handleFooterAction(action);
    }
  },

  computed: {
    cdPessoa() {
      return this.$store?.state?.me?.cd_pessoa || null;
    },

    questionarioTitulo() {
      return this.questionarioTituloData || "Questionario de acompanhamento";
    },

    totalPerguntasFormulario() {
      return Number(this.formState.total || 0);
    },

    perguntaAtualFormulario() {
      return Number(this.formState.current || 0);
    },

    perguntaAtualQuestionario() {
      return Number(this.questionarioData?.pergunta_atual || 0);
    },

    cdPerguntaAtualQuestionario() {
      return Number(this.questionarioData?.cd_pergunta || 0);
    },

    perguntaAtualObrigatoria() {
      return ["O", "E", true].includes(this.questionarioData?.obrigatorio);
    },

    perguntaAtualEhTextarea() {
      return this.questionarioData?.tipo_resposta === "D";
    },

    bloquearProximoAtual() {
      if (this.formState.enviando) {
        return true;
      }

      if (this.estaNaUltimaPergunta) {
        return false;
      }

      if (
        this.perguntaAtualEhTextarea &&
        this.questionarioData?.obrigatorio !== "E" &&
        this.perguntaAtualObrigatoria
      ) {
        return (
          Number(this.formState.comprimentoResposta || 0) <
          Number(this.formState.minimoCaracteres || 15)
        );
      }

      return !this.formState.respostaValida || this.formState.bloquearProximo;
    },

    estaNaPrimeiraPergunta() {
      if (this.fluxoIniciado) {
        return false;
      }

      if (this.cdPerguntaAtualQuestionario === 1) {
        return true;
      }

      if (this.perguntaAtualQuestionario > 0) {
        return this.perguntaAtualQuestionario === 1;
      }

      if (this.perguntaAtualFormulario > 0) {
        return this.perguntaAtualFormulario === 1;
      }

      return this.formState.isPrimeiraPergunta;
    },

    estaNaUltimaPergunta() {
      if (this.questionarioData?.ultima_pergunta !== undefined) {
        return Boolean(this.questionarioData?.ultima_pergunta);
      }

      return this.formState.isUltimaPergunta;
    }
  },

  mounted() {
    this.cdCooperadoAtual = this.cdCooperado || this.cdPessoa;
    this.carregarCampanha();
  },

  methods: {
    isPendenciaCompativel(pendencia) {
      return Boolean(pendencia?.cdProced);
    },

    registrarProgressoPergunta(pergunta = {}) {
      const totalBackend = Number(pergunta?.total_perguntas || 0);
      const porcentagemBackend = Number(pergunta?.porcentagem);

      if (totalBackend > this.totalEstimado) {
        this.totalEstimado = totalBackend;
      }

      if (!Number.isNaN(porcentagemBackend)) {
        return porcentagemBackend;
      }

      return null;
    },

    marcarPerguntaConcluida(cdPergunta) {
      if (
        cdPergunta !== null &&
        cdPergunta !== undefined &&
        cdPergunta !== ""
      ) {
        this.perguntasVistas.add(String(cdPergunta));
      }
    },

    calcularPercentualProgresso(pergunta = {}) {
      const porcentagemBackend = this.registrarProgressoPergunta(pergunta);

      if (porcentagemBackend !== null) {
        return porcentagemBackend;
      }

      const total = Math.max(this.totalEstimado, 1);

      return Math.min(99, Math.round((this.perguntasVistas.size / total) * 100));
    },

    calcularProgressoFormulario(pergunta = {}) {
      const current = Number(pergunta?.pergunta_atual || 0);
      const total = Number(pergunta?.total_perguntas || 0);
      const ultimaPergunta = Boolean(pergunta?.ultima_pergunta);
      const totalProgresso = Math.max(total, this.totalEstimado, 1);
      const percentBackend = Number(pergunta?.porcentagem);
      const percent = Number.isNaN(percentBackend)
        ? this.calcularPercentualProgresso(pergunta)
        : percentBackend;

      return {
        current,
        total: totalProgresso,
        percent,
        isPrimeiraPergunta: current === 1,
        isUltimaPergunta: ultimaPergunta
      };
    },

    sincronizarEstadoPergunta(pergunta = {}) {
      const progresso = this.calcularProgressoFormulario(pergunta);

      this.formState = {
        ...this.formState,
        ...progresso
      };
    },

    sincronizarEstadoPerguntaAoVoltar(pergunta = {}, perguntaAtualOrigem = 0) {
      const currentBackend = Number(pergunta?.pergunta_atual || 0);
      const cdPergunta = Number(pergunta?.cd_pergunta || 0);
      const totalBackend = Number(pergunta?.total_perguntas || 0);
      this.registrarProgressoPergunta(pergunta);
      const currentCalculado =
        cdPergunta === 1
          ? 1
          : currentBackend > 0
          ? currentBackend
          : Math.max(1, Number(perguntaAtualOrigem || 1) - 1);
      const isPrimeiraPergunta = cdPergunta === 1 || currentCalculado === 1;
      const total = Math.max(
        totalBackend,
        this.totalEstimado,
        Number(this.formState.total || 0),
        1
      );

      this.formState = {
        ...this.formState,
        current: currentCalculado,
        total,
        percent: this.calcularProgressoFormulario(pergunta).percent,
        isPrimeiraPergunta,
        isUltimaPergunta: Boolean(pergunta?.ultima_pergunta)
      };
    },

    normalizarPerguntaRetornadaAoVoltar(
      pergunta = {},
      perguntaAtualOrigem = 0
    ) {
      const totalBackend = Number(pergunta?.total_perguntas || 0);
      const cdPergunta = Number(pergunta?.cd_pergunta || 0);
      const totalAtual = Number(this.formState.total || 0);
      const total = Math.max(totalBackend, totalAtual, 1);
      const currentCalculado =
        cdPergunta === 1
          ? 1
          : Math.max(1, Number(perguntaAtualOrigem || 1) - 1);

      return {
        ...pergunta,
        pergunta_atual: currentCalculado,
        total_perguntas: total,
        ultima_pergunta: Boolean(pergunta?.ultima_pergunta)
      };
    },

    emitirHeaderChange(config = {}) {
      this.$emit("header-change", {
        titulo: this.questionarioTitulo,
        icon: "mdi-clipboard-text-outline",
        showProgress: true,
        progress: {
          current: config.current || this.formState.current || 1,
          total: config.total || this.formState.total || 1,
          percent:
            config.percent !== undefined
              ? config.percent
              : this.formState.percent || 0
        }
      });
    },

    handleValidacaoResposta(dados) {
      // Atualiza o estado de validação da resposta
      this.formState.respostaValida = this.estaNaUltimaPergunta
        ? true
        : Boolean(dados?.valida);
      if (dados?.minimo !== undefined && dados?.minimo !== null) {
        this.formState.minimoCaracteres = Number(dados.minimo);
      }

      if (dados?.comprimento !== undefined && dados?.comprimento !== null) {
        this.formState.comprimentoResposta = Number(dados.comprimento);
      }
      // Re-emite o footer para atualizar o estado dos botões
      this.emitirFooterChange();
    },

    emitirFooterChange() {
      const acoes = [];
      const exibirAcaoInicial = this.estaNaPrimeiraPergunta;
      const acaoEmAndamento =
        Boolean(this.loadingAction) || this.formState.enviando;

      if (!this.estaNaPrimeiraPergunta) {
        acoes.push({
          id: "back",
          visible: true,
          label: "Voltar",
          variant: "secondary",
          icon: "mdi-arrow-left",
          class: "button-soft-secondary",
          disabled: acaoEmAndamento,
          loading: this.loadingAction === "back"
        });
      }

      if (exibirAcaoInicial) {
        acoes.push({
          id: "start",
          visible: true,
          variant: "success",
          label: "Vamos Começar",
          icon: "mdi-arrow-right",
          class: "button-soft-success",
          disabled: acaoEmAndamento,
          loading: this.loadingAction === "start",
        });
      } else if (!this.estaNaUltimaPergunta) {
        acoes.push({
          id: "next",
          visible: true,
          label: "Proximo",
          variant: "primary",
          icon: "mdi-arrow-right",
          class: "button-soft-primary",
          loading: this.loadingAction === "next",
          disabled: this.bloquearProximoAtual || acaoEmAndamento
        });
      } else {
        acoes.push({
          id: "submit",
          visible: true,
          label: "Finalizar",
          variant: "success",
          icon: "mdi-flag-checkered",
          class: "button-finalizar-vitoria",
          loading: this.loadingAction === "submit",
          disabled: this.bloquearProximoAtual || acaoEmAndamento
        });
      }

      this.$emit("footer-change", {
        show: true,
        actions: acoes
      });
    },

    obterPendenciaVerificadaDaStore() {
      const estadoCampanha = this.$store?.state?.acompanhamentoMensal;

      if (
        !estadoCampanha?.verificado ||
        !estadoCampanha?.temPendencia ||
        !estadoCampanha?.pendenciaAtual
      ) {
        return null;
      }

      return {
        status: true,
        data: {
          temPendencia: true,
          campanha: estadoCampanha.pendenciaAtual
        }
      };
    },

    async carregarCampanha() {
      this.carregando = true;
      this.erro = null;
      this.questionarioData = null;
      this.cdProcedAtual = null;
      this.questionarioTituloData = "";
      this.fluxoIniciado = false;
      this.perguntasVistas = new Set();
      this.totalEstimado = 0;

      try {
        const cooperado = this.cdCooperado || this.cdPessoa;

        if (!cooperado) {
          this.erro = "Nao foi possivel identificar o cooperado.";
          return;
        }

        let resultadoVerificacao = this.obterPendenciaVerificadaDaStore();

        if (!resultadoVerificacao) {
          resultadoVerificacao = await verificarPendenciaService.verificar(
            cooperado
          );

          await this.$store.dispatch(
            "acompanhamentoMensal/setCampanhaPendencia",
            resultadoVerificacao
          );
        }

        const pendencia = questionarioAdapter.mapPendencia(
          resultadoVerificacao
        );

        if (!pendencia.success) {
          this.erro = pendencia.error || "Erro ao verificar pendencias.";
          return;
        }

        if (!this.isPendenciaCompativel(pendencia)) {
          this.erro = "A pendencia encontrada nao pertence a esta campanha.";
          return;
        }

        const resultadoRetomada = await questionarioService.retomarQuestionario(
          Number(cooperado),
          Number(pendencia.cdProced)
        );

        const resultadoInicio = resultadoRetomada.success
          ? resultadoRetomada
          : await questionarioService.iniciarQuestionario(
              Number(cooperado),
              Number(pendencia.cdProced)
            );

        const questionario = questionarioAdapter.mapQuestionarioInicial(
          resultadoInicio
        );

        if (!questionario.success) {
          this.erro =
            questionario.error || "Erro ao carregar questionario.";
          return;
        }

        this.cdCooperadoAtual = pendencia.cdCooperado || cooperado;
        this.cdProcedAtual = pendencia.cdProced;
        this.questionarioData = questionario.questionarioData || null;
        this.questionarioTituloData = questionario.titulo || "";
        this.$root.$emit("campanha:titulo-proced", questionario.titulo || "");
        this.sincronizarEstadoPergunta(this.questionarioData || {});
      } catch (error) {
        this.handleErro(error);
      } finally {
        this.carregando = false;
      }
    },

    handleFormStateChange(formState) {
      const progressoAtual = this.calcularProgressoFormulario(
        this.questionarioData || {}
      );
      const percent =
        formState?.percent !== undefined && formState?.percent !== null
          ? Number(formState.percent)
          : progressoAtual.percent;

      this.formState = {
        ...this.formState,
        ...formState,
        ...progressoAtual,
        percent: Number.isNaN(percent) ? progressoAtual.percent : percent
      };

      this.emitirHeaderChange(this.formState);
      this.emitirFooterChange();
    },

    async handleFooterAction(action) {
      const form = this.$refs.questionarioForm;

      if (!form || this.loadingAction || this.formState.enviando) {
        return;
      }

      if (action !== "back") {
        const validacao =
          typeof form.validarQuantidadeResposta === "function"
            ? form.validarQuantidadeResposta()
            : { valida: true };

        if (!validacao.valida) {
          this.$tools.alerta(validacao.mensagem, "warning");
          return;
        }
      }

      this.loadingAction = action;
      this.emitirFooterChange();

      if (action === "back") {
        await this.voltarPerguntaAtual(form);
        return;
      }

      if (action === "start" || action === "next") {
        await this.enviarRespostaAtual(form);
        this.fluxoIniciado = true;
        return;
      }

      if (action === "submit") {
        await this.enviarRespostaAtual(form, {
          finalizarFluxo: true
        });
      }
    },

    async enviarRespostaAtual(form, options = {}) {
      const { finalizarFluxo = false } = options;
      const respostaAtual = form.getRespostaAtualPayload();
      const STATUS_SEM_RESPOSTAS = [422];

      form.iniciarEnvio();
      try {
        const isTipoLikert = this.questionarioData?.tipo_resposta === "L";

        const payload = isTipoLikert
          ? {
              cdCooperado: Number(this.cdCooperadoAtual),
              cdProced: Number(this.cdProcedAtual),
              cdPergunta: Number(respostaAtual?.cdPergunta),
              cdResposta: respostaAtual?.cdResposta
                ? `cd_resposta|${respostaAtual.cdResposta}|`
                : null,
              voltando: 0,
              respostasLikert: form.getRespostasLikert().map(r => ({
                cdCooperado: Number(this.cdCooperadoAtual),
                cdProced: Number(this.cdProcedAtual),
                cdPergunta: r.cdPergunta,
                cdResposta: r.cdResposta
              }))
            }
          : questionarioAdapter.mapRespostaBackendPayload({
              cdCooperado: this.cdCooperadoAtual,
              cdProced: this.cdProcedAtual,
              cdPergunta: respostaAtual?.cdPergunta,
              cdResposta: respostaAtual?.cdResposta
            });

        const resultado = finalizarFluxo
          ? await questionarioService.finalizarQuestionario({
              cdCooperado: Number(this.cdCooperadoAtual),
              cdProced: Number(this.cdProcedAtual)
            })
          : await questionarioService.responderQuestionario(payload);
        if (!resultado.success) {
          if (STATUS_SEM_RESPOSTAS.includes(resultado.statusCode)) {
            this.$tools.alerta(
              "Por favor, responda pelo menos uma pergunta.",
              "warning"
            );
            form.enviando = false;
            form.emitirEstadoFormulario();
            return { success: false };
          }

          form.finalizarEnvioComErro(
            resultado.error ||
              (finalizarFluxo
                ? "Erro ao finalizar questionario"
                : "Erro ao enviar respostas")
          );
          return { success: false };
        }

        if (!finalizarFluxo && resultado.data) {
          this.marcarPerguntaConcluida(respostaAtual?.cdPergunta);
          this.marcarPerguntaConcluida(respostaAtual?.cdPergunta);
          const perguntaMapeada = questionarioAdapter.mapPergunta(
            resultado.data
          );
          this.questionarioData = perguntaMapeada;
          this.sincronizarEstadoPergunta(perguntaMapeada);
          this.fluxoIniciado = true;
        }

        if (finalizarFluxo) {
          this.marcarPerguntaConcluida(respostaAtual?.cdPergunta);
          this.formState = {
            ...this.formState,
            percent: 100
          };
          this.emitirHeaderChange(this.formState);
          form.finalizarEnvioComSucesso(resultado);

          // Comemora somente depois que o backend confirmou a finalização.
          this.dispararConfetesFinalizacao();

          try {
            const temOutraPendencia = await this.$store.dispatch(
              "acompanhamentoMensal/verificarPendenciaCampanha",
              { force: true }
            );

            if (temOutraPendencia) {
              await this.carregarCampanha();
            } else if (this.$router && this.$route.fullPath !== "/") {
              this.$router.push("/");
            }
          } catch (clearError) {
            console.error("[AcompanhamentoMensal] erro ao verificar pendencia", clearError);
            if (this.$router && this.$route.fullPath !== "/") {
              this.$router.push("/");
            }
          }
        } else {
          form.enviando = false;
        }

        return {
          success: true,
          resultado
        };
      } catch (error) {
        form.finalizarEnvioComErro(
          error?.message || "Erro inesperado ao enviar respostas"
        );
        return { success: false, error };
      } finally {
        this.loadingAction = "";
        this.emitirFooterChange();
      }
    },

    async handleSubmitResposta() {
      const form = this.$refs.questionarioForm;

      if (!form) {
        return;
      }

      await this.enviarRespostaAtual(form, {
        finalizarFluxo: true
      });
    },

    handleErro(erro) {
      this.erro =
        typeof erro === "string"
          ? erro
          : erro?.message || "Erro ao processar campanha.";
    },

    handleRespostasEnviadas(dados) {
      this.$emit("completed", dados);
    },

    dispararConfetesFinalizacao() {
      const duracao = 1400;
      const fim = Date.now() + duracao;
      const opcoesBase = {
        spread: 65,
        startVelocity: 40,
        ticks: 220,
        zIndex: 3000,
        colors: ["#12b76a", "#34c38f", "#f1b44c", "#556ee6", "#ffffff"]
      };

      const intervalo = setInterval(() => {
        const tempoRestante = fim - Date.now();

        if (tempoRestante <= 0) {
          clearInterval(intervalo);
          return;
        }

        const quantidadeParticulas = Math.max(
          8,
          Math.floor((tempoRestante / duracao) * 40)
        );

        confetti({
          ...opcoesBase,
          particleCount: quantidadeParticulas,
          origin: { x: 0.15 + Math.random() * 0.2, y: 0.7 }
        });

        confetti({
          ...opcoesBase,
          particleCount: quantidadeParticulas,
          origin: { x: 0.65 + Math.random() * 0.2, y: 0.7 }
        });
      }, 220);
    },

    async voltarPerguntaAtual(form) {
      const respostaAtual = form.getRespostaAtualPayload({
        incluirResposta: false
      });
      const perguntaAtualOrigem = Number(respostaAtual?.perguntaAtual || 0);
      form.iniciarEnvio();

      try {
        const payload = questionarioAdapter.mapVoltarPerguntaPayload({
          cdCooperado: this.cdCooperadoAtual,
          cdProced: this.cdProcedAtual,
          cdPergunta: respostaAtual?.cdPergunta,
          cdResposta: respostaAtual?.cdResposta
        });

        const resultado = await questionarioService.voltarQuestionario(payload);

        if (!resultado.success) {
          form.finalizarEnvioComErro(
            resultado.error || "Erro ao voltar pergunta"
          );
          return;
        }

        if (resultado.data) {
          const perguntaMapeada = questionarioAdapter.mapPergunta(
            resultado.data
          );
          const cdPerguntaRetornada = perguntaMapeada?.cd_pergunta;

          if (
            cdPerguntaRetornada !== null &&
            cdPerguntaRetornada !== undefined &&
            cdPerguntaRetornada !== ""
          ) {
            this.perguntasVistas.delete(String(cdPerguntaRetornada));
          }

          const perguntaNormalizada = this.normalizarPerguntaRetornadaAoVoltar(
            perguntaMapeada,
            perguntaAtualOrigem
          );
          this.questionarioData = perguntaNormalizada;
          this.sincronizarEstadoPerguntaAoVoltar(
            perguntaNormalizada,
            perguntaAtualOrigem
          );
          this.fluxoIniciado = this.questionarioData?.cd_pergunta !== 1;
          form.limparRespostaAtual();
        }

        form.enviando = false;
      } catch (error) {
        form.finalizarEnvioComErro(
          error?.message || "Erro inesperado ao voltar pergunta"
        );
      } finally {
        this.loadingAction = "";
        this.emitirFooterChange();
      }
    }
  }
};
</script>

<style lang="scss">
.acompanhamento-mensal-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 1.25rem;
  box-sizing: border-box;
}
.start-questionario h5,
.start-questionario p {
  color: #13345a;
}

.conteudo-campanha {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-height: 0;
}

.button-soft-secondary > div {
  flex-direction: row-reverse;
}

.button-soft-secondary:focus,
.button-soft-secondary:hover {
  color: #636678 !important;
  background-color: rgba(116, 120, 141, 0.1);
  box-shadow: 0 0 0 0.15rem rgba(137, 140, 158, 0.5);
  -webkit-box-shadow: 0 0 0 0.15rem rgba(137, 140, 158, 0.5);
}

.button-soft-primary:focus,
.button-soft-primary:hover {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.1);
  box-shadow: 0 0 0 0.15rem rgba(111, 132, 234, 0.5);
  -webkit-box-shadow: 0 0 0 0.15rem rgba(111, 132, 234, 0.5);
}

.button-soft-success:focus,
.button-soft-success:hover {
  color: #34c38f;
  border-color: transparent;
  border: 1px solid #34c38f;
  background-color: rgba(52, 195, 143, 0.1);
  box-shadow: 0 0 0 0.15rem rgba(82, 204, 160, 0.5);
  -webkit-box-shadow: 0 0 0 0.15rem rgba(82, 204, 160, 0.5);
}

.button-finalizar-vitoria {
  position: relative;
  overflow: hidden;
  color: #ffffff !important;
  border: none !important;
  background: linear-gradient(
    135deg,
    #079455 0%,
    #12b76a 52%,
    #06904f 100%
  ) !important;
  box-shadow:
    0 8px 20px rgba(18, 183, 106, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.35) !important;
  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease !important;
}

.button-finalizar-vitoria:hover,
.button-finalizar-vitoria:focus {
  color: #ffffff !important;
  border-color: transparent !important;
  transform: translateY(-2px);
  background: linear-gradient(
    135deg,
    #078c50 0%,
    #19c374 52%,
    #058448 100%
  ) !important;
  box-shadow:
    0 12px 25px rgba(18, 183, 106, 0.38),
    inset 0 1px 0 rgba(255, 255, 255, 0.4) !important;
}

.button-finalizar-vitoria:active {
  transform: scale(0.96);
}

.button-finalizar-vitoria::after {
  content: "";
  position: absolute;
  top: -70%;
  left: -50%;
  width: 32px;
  height: 240%;
  pointer-events: none;
  transform: rotate(25deg);
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.15),
    rgba(255, 255, 255, 0.85),
    rgba(255, 255, 255, 0.15),
    transparent
  );
  filter: blur(1px);
  transition: left 0.7s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.button-finalizar-vitoria:hover::after {
  left: 125%;
}

</style>